module.exports = __webpack_public_path__ + "img/as-pdf.f0387994.svg";